import { useState } from "react";
import { tw } from "@careinfo/tailwind";
import { useDownload } from "@careinfo/layout";
import moment from "moment";
 
import { toHaveFormValues } from "@testing-library/jest-dom/matchers";
import APIS from "../../../constant/Endpoint";
import Button from "../Button";


function calculateTotal(data) {
  if (!Array.isArray(data)) return 0;
  return data.reduce((sum, item) => {
    const selfBalance = Number(item?.balance) || 0;
    const childrenBalance = calculateTotal(item?.children);
    return sum + selfBalance + childrenBalance;
  }, 0);
}

function Table({ data, title, isLoading, netProfitLoss }) {
  const { download } = useDownload();
  const total = calculateTotal(data);
  const profitLoss = Number(netProfitLoss || 0);
const handleDownloadExcel = async () => {
    try {
      const cleanedParams = Object.fromEntries(
        Object.entries(toHaveFormValues)
          .filter(
            ([, value]) => value !== null && value !== undefined && value !== ""
          )
          .map(([key, value]) => [key, String(value)])
      );

      const queryString = new URLSearchParams(cleanedParams).toString();

      await download(
        `${APIS.PRODUCT}valuation-excel-download/?${queryString}`,
        `stock-valuation-${moment().format("MMMM-Do-YYYY-h-mm-ss")}.xlsx`
      );
    } catch (e) {
      console.error(e);
    }
  };
  return (
    
    <div>
      <div
        className={tw`grid grid-cols-6 bg-primary text-white rounded-t-md p-2 border border-[#dcdcdc]`}
      >
        <span className={tw`col-span-2 justify-self-start`}>{title}</span>
        <span className={tw`justify-self-center`}>Schedule</span>
        <span className={tw`justify-self-center`}>Amount</span>
      </div>

      {isLoading
        ? Array.from({ length: 5 }).map((_, index) => (
            <div
              key={index}
              className={tw`h-10 w-full bg-white animate-pulse border border-[#dcdcdc]`}
            ></div>
          ))
        : data?.map((c) => (
            <TableSection title={title} key={c.name} data={c} />
          ))}

      {title === "Source of Fund" && profitLoss > 0 && (
        <p
          className={tw`grid grid-cols-6 p-2 border border-[#dcdcdc] bg-gray-100`}
        >
          <span className={tw`col-span-2 justify-self-start`}>
            Net Profit transferred from P&amp;L A/c
          </span>
          <span></span>
          <span className={tw`justify-self-center`}>
            {profitLoss.toLocaleString("en-IN", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </span>"../Reusable/Button"
        </p>
      )}
      {title === "Application of Fund" && profitLoss < 0 && (
        <p
          className={tw`grid grid-cols-6 p-2 border border-[#dcdcdc] bg-gray-100`}
        >
          <span className={tw`col-span-2 justify-self-start`}>
            Net Loss transferred from P&amp;L A/c
          </span>
          <span></span>
          <span className={tw`justify-self-center`}>
            {Math.abs(profitLoss).toLocaleString("en-IN", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </span>
        </p>
      )}

      <p
        className={tw`grid grid-cols-6 p-2 border border-[#dcdcdc] bg-gray-200`}
      >
        <span className={tw`col-span-2 justify-self-start`}>Total</span>
        <span></span>
        <span className={tw`justify-self-center`}>
          {(() => {
            let value = total;

            if (title === "Application of Fund" && profitLoss < 0) {
              value += profitLoss;
            } else if (title === "Source of Fund" && profitLoss > 0) {
              value += profitLoss;
            }

            return Math.abs(Number(value)).toLocaleString("en-IN", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            });
          })()}
        </span>
      </p>
    </div>
  );
}

function TableSection({ data, title }) {
  const hasChildren = data?.children && data.children.length > 0;

  // If it has children, recurse into them
  if (hasChildren) {
    return (
      <>
      
        {data.children.map((child) => (
          <TableSection key={child.name} data={child} title={title} />
        ))}
      </>
    );
  }

  // Leaf node (no children) -> show balance
  return (
    
    <p className={tw`grid grid-cols-6 bg-gray-50 p-2 border border-[#dcdcdc]`}>
      <span className={tw`col-span-2 justify-self-start`}>{data?.name}</span>
      <span className={tw`justify-self-center`}></span>
      <span className={tw`justify-self-center`}>
        {title === "Source of Fund"
          ? Number(data?.balance).toLocaleString("en-IN", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })
          : Math.abs(data?.balance).toLocaleString("en-IN", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
      </span>
    </p>
  );
}

const BalanceSheetTable = ({ balanceSheetData, isLoading }) => {
  const netProfitLoss = balanceSheetData?.results?.net_profit ?? 0;

  return (
    <div className={tw`space-y-2`}>
      <Table
        data={balanceSheetData?.results?.source_of_funds}
        isLoading={isLoading}
        title={"Source of Fund"}
        netProfitLoss={netProfitLoss}
      />
      <Table
        data={balanceSheetData?.results?.application_of_funds}
        isLoading={isLoading}
        title={"Application of Fund"}
        netProfitLoss={netProfitLoss}
      />
    </div>
  );
};

export default BalanceSheetTable;
